export const Chevron = (h) => (props) => (h("svg", { ...props, xmlns: "http://www.w3.org/2000/svg", fill: "none", stroke: "currentColor", "aria-hidden": "true", viewBox: "0 0 24 24" }, h("path", { d: "m18.5 9-6 6-6-6" })));
//# sourceMappingURL=Chevron.js.map
